import http from "./http";

//获取单选问题
export function get_choice_api() {
  return new Promise((resolve, reject) => {
    http.get("/question/single_choice_question").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//创建单选题
export function post_question_choice_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/single_choice_question", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//创建多选题   
export function post_multiple_choice_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/multi_choices_question", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//创建判断题    
export function post_true_false_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/true_false_question", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//创建问答题     
export function post_answer_question_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/answer_question", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//创建scratch题      
export function post_scratch_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/scratch_question", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//删除问题
export function delete_question(data) {
  return new Promise((resolve, reject) => {
    http.delete("/question?name=" + data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//创建题库 
export function post_question_sheet_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/sheet", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//获取题库 
export function get_question_sheet_api() {
  return new Promise((resolve, reject) => {
    http.get("/question/sheet").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//学生获取题库 
export function get_student_question_sheet_api() {
  return new Promise((resolve, reject) => {
    http.get("/question/sheet?cloned=true").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改题库
export function put_question_sheet_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/question/sheet" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//获取题库下问题 
export function get_sheet_detail_api(id) {
  return new Promise((resolve, reject) => {
    http.get("/question/sheet_detail?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//添加试题到题库  
export function post_add_question_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/question/add_question" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//编辑单选题 
export function put_choice_questions_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/question/single_choice_question" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//编辑多选题 
export function put_multiple_choice_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/question/multi_choices_question" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//编辑判断题  
export function put_true_false_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/question/true_false_question" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//编辑问答题   
export function put_answer_question_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/question/answer_question" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//编辑scratch题    
export function put_scratch_api(data) {
  return new Promise((resolve, reject) => {
    http.put("/question/scratch_question" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//查找班级信息 
export function get_class_question_api(id) {
  return new Promise((resolve, reject) => {
    http.get("/school/class/detail?id=" + id ).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//班级分配作业 
export function post_class_sheet_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/school/class/add_sheet" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//班级分配作业 
export function put_school_sheet_api(data) {
  return new Promise((resolve, reject) => {
    http.put("school/sheet" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//
export function put_teacher_sheet_api(data) {
  return new Promise((resolve, reject) => {
    http.put("school/user/sheet" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//删除班级题库
export function post_remove_sheet_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/school/class/remove_sheet" , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//学生提交题目
export function put_answer_api(id,data) {
  return new Promise((resolve, reject) => {
    http.put("/question/answer?id=" + id , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//学生提交题库 
export function put_submission_api(id) {
  return new Promise((resolve, reject) => {
    http.put("/question/sheet/submission?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//获取班级下面的题库
export function get_class_sheet_api(id) {
  return new Promise((resolve, reject) => {
    http.get("/school/class/sheet?id=" + id ).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//获取班级下面的题库
export function get_answer_api(id) {
  return new Promise((resolve, reject) => {
    http.get("/question/answer?id=" + id ).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//老师获取学生提交的题目
export function get_user_answer_api(question , user) {
  return new Promise((resolve, reject) => {
    http.get("/question/answer/user?question=" + question + '&user=' + user ).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//批改题目 
export function put_user_answer_api(id , score) {
  return new Promise((resolve, reject) => {
    http.put("/question/answer/score?id=" + id + '&score=' + score ).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取试卷总分
export function get_score_api(user , sheet) {
  return new Promise((resolve, reject) => {
    http.get("/question/sheet/user/info?user=" + user + '&sheet=' + sheet ).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}